import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Strong, List, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"dlya-chego-sozdat-magazin-v-Telegram"} />
		<Helmet>
			<title>
				Для чего создавать магазин в Телеграм
			</title>
			<meta name={"description"} content={"Рассказываем зачем необходим бизнесу интернет-магазин в формате бота в Telegram"} />
			<meta property={"og:title"} content={"Для чего создавать магазин в Телеграм"} />
			<meta property={"og:description"} content={"Рассказываем зачем необходим бизнесу интернет-магазин в формате бота в Telegram"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Создание интернет-магазина
							</Link>
							<Link
								href="/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Подключение бота
							</Link>
							<Link
								href="/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Онлайн оплата
							</Link>
							<Link
								href="/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Link
						href="https://t.me/uShopWebBot"
						color="--white"
						font="--button"
						text-decoration-line="initial"
						padding="12px 24px 12px 24px"
						background="--dark"
						border-radius="50px"
						transition="--opacityOut"
						hover-opacity=".8"
						target="_blank"
						md-padding="12px 20px 12px 20px"
					>
						Создать магазин
					</Link>
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 99.5%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override
				slot="SectionContent"
				align-items="flex-start"
				display="flex"
				grid-template-columns="2fr 1fr"
				grid-gap="16px"
			/>
			<Box
				min-width="100px"
				min-height="100px"
				md-align-items="center"
				md-display="flex"
				md-flex-direction="column"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="--headline1"
					md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
					sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
					color="--white"
					as="h1"
					md-text-align="center"
				>
					Нужен ли интернет-магазин в Телеграм для бизнеса?{"\n\n"}
				</Text>
				<Text
					margin="8px 0px 48px 0px"
					font="--headline3"
					color="--white"
					as="h4"
					md-text-align="center"
				>
					Давайте разберемся, а стоит ли создавать магазин в Телеграм и заниматься его продвижением..
				</Text>
				<Link
					href="https://t.me/uSportClothes"
					color="--white"
					font="--button"
					text-decoration-line="initial"
					padding="16px 28px 16px 28px"
					background="--primary"
					border-radius="50px"
					transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
					hover-color="--dark"
					hover-background="--white"
					target="_blank"
					text-align="center"
				>
					Пример интернет-магазина в Telegram
				</Link>
			</Box>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text
				id="shop"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Для чего создавать магазин в Telegram?
			</Text>
			<Text margin="0px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				Разве недостаточно продвигать интернет-магазин во “ВКонтакте”? Во-первых, помните,
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{" "}что чем больше каналов вы используете для раскрутки своего бизнеса - тем больше эффект
				</Strong>
				. Во-вторых, у “Telegram” есть уникальные преимущества, которые не обеспечит вам никакая другая соцсеть.
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Что это за преимущества?{"\n\n"}
				</Strong>
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="decimal"
				as="ul"
				font="--base"
			>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Онлайн оплата.{" "}
					</Strong>
					Первый и самый важный плюс, это возможность подключить онлайн оплату прямо внутри мессенджера, то есть пользователя не будет перебрасывать на какой-то сторонний сайт, у него просто откроется форма оплаты для ввода своих банковских данных прямо внутри мессенджера.{" "}
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Автоматизация.{" "}
					</Strong>
					Продажа ваших товаров может происходить без вашего участия, пользователь может выбрать любой товар и оплатить его не вступая в диалог с владельцем магазина. А если вы продаете электронные товары, то и получение товара происходит полностью без вашего участия.
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						В Telegram нет рекламы,{" "}
					</Strong>
					всплывающих окон, мигающих баннеров, шоковых заголовков. Это мессенджер для современных думающих людей, которые давно наелись обычной рекламой и устали от бесконечного спама. А если и есть реклама в других каналах, то она не таргетированная, то есть когда пользователь зайдет в каталог вашей пиццерии, то ему реклама других пиццерий в будущем таргетироваться не будет и вы точно не потеряете своего клиента.
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Низкая конкуренция.{" "}
					</Strong>
					Интернет-магазинов в Telegram практически нет и нища в каждой категории товаров или услуг практически пуста.
				</Text>
			</List>
			<Text margin="12px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				/>
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Link
						href="https://t.me/uShopWebBot"
						target="_blank"
						text-decoration-line="initial"
						color="--primary"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Создать интернет-магазин в Telegram
					</Link>
				</Strong>
				{" "}можно единственным способом - создав бота. Бот облегчает задачу владельцам бизнеса и создает автоворонку, так как в боте будет расположен весь ваш каталог товаров, которые будут отсортированы по категориям, в боте будет предусмотрена корзина, онлайн оплата и вариации способа доставки товара по адресу покупателя.
			</Text>
			<Text margin="24px 0px 12px 0px" font="--headline3" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" as="h3">
				<Strong>
					Почему Телеграм-бот, а не полноценное мобильное приложение?{"\n\n"}
				</Strong>
			</Text>
			<Text margin="0px 0px 24px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				Мы ни в коем случае не приуменьшаем возможностей и полезности полноценных мобильных приложений, которые нужно скачивать в телефон пользователя через различные магазины приложений. Однако, тенденция создания приложений возрастает и конкурировать за место в памяти телефона клиента становится все сложнее, а если и во все клиенту нужно сделать только единичный заказ ради которого нужно скачивать целое приложение, что выглядит очень не рационально.
				<br />
				<br />
				То есть основная фишка Telegram-бота в его доступности, пользователю нужно будет просто ввести в поисковой строке названия вашего бота и ему сразу будет доступен ваш каталог с онлайн оплатой. Вы также можете совершать рассылки на всех пользователей которые запустили бота, информируя о скидках или акциях вашего бизнеса.
			</Text>
			<Text
				margin="0px 0px 12px 0px"
				font="normal 500 18px/25px --fontFamily-googleMontserrat"
				padding="0px 0px 0px 10px"
				border-width="0px 0px 0px 2px"
				border-style="solid"
				border-color="--color-dark"
				as="h4"
			>
				С Telegram ботом пользователю не придется дополнительно скачивать приложение, весь функционал интернет-магазина с онлайн оплатой и интегрированной службой доставки будет прямо в мессенджере!
			</Text>
			<Image src="https://ukit.top/avatar/magazine.gif" display="block" border-width="1px" border-style="solid" />
			<Text margin="0px 0px 0px 0px" font="italic 500 16px/160% --fontFamily-googleMontserrat" sm-font="italic 500 14px/160% --fontFamily-googleMontserrat">
				Демонстрация покупки товара с канала{" "}
				<Link
					href="https://t.me/uSportClothes"
					color="--primary"
					text-decoration-line="initial"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@uSportClothes
				</Link>
				{" "}и с бота{" "}
				<Link href="https://t.me/SportClothesBot" target="_blank" color="--primary" text-decoration-line="initial">
					@SportClothesBot
				</Link>
				{" "}с онлайн оплатой
			</Text>
			<Text margin="24px 0px 0px 0px" font="--base">
				Как мне кажется мы ответили на вопрос и что сейчас рынок открыт и ему нужны магазин абсолютно разных тематик. Начать создание своего магазина, вы можете с создания веб-бота в котором разместите весь ваш товар. Как создать магазин можете прочитать в этой{" "}
				<Link
					href="/instrukciya/"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					инструкции
				</Link>
				. Если бот у вас уже создан, то вы можете начать продвигать его, как правильно это делать мы описали в этой{" "}
				<Link
					href="/prodvizhenie-internet-magazina-v-telegram/"
					text-decoration-line="initial"
					color="--primary"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					статье
				</Link>
				.
			</Text>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Заказать интернет-магазин в формате бота

в Telegram за 2000 руб.
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
		</RawHtml>
	</Theme>;
});